import './UpgradePopout.css'

import React from 'react'
import PropTypes from 'prop-types'
import {
  Popout,
  PopoutHeader,
  PopoutBody,
  PopoutFooter,
  PopoutAlign,
  Button
} from '@sm/wds-react'
import { IconLock } from '@sm/wds-icons'
import { WUFOO_PRICING_LINK } from '../../../../common/constants/formLinks'
import { LegacyLink } from '../../../../common/components/LegacyLink'
import { getUpgradeCTAClickedEventDetails } from '../../../../common/models/mixpanel'
import { mixpanel } from '../../../../common/services/telemetry/mixpanel'


export const UpgradePopout = props => {
  const {
    body,
    placement,
    renderTo,
    shouldSendTrackingEvent,
    trackingEventProps,
    translate,
    trigger,
  } = props

  const handleClick = () => {
    const { upgradeTextKey, location } = trackingEventProps || {}
    const eventDetails = getUpgradeCTAClickedEventDetails(upgradeTextKey, `${location} Upgrade Popout`)
    mixpanel.track(eventDetails.event, eventDetails.properties)
  }

  return (
    <Popout
      className='upgrade-popout'
      placement={placement}
      renderTo={renderTo}
      trigger={trigger}
    >
      <PopoutHeader>
        <IconLock />
        {translate('Paid_feature')}
      </PopoutHeader>

      <PopoutBody>
        {body}
      </PopoutBody>

      <PopoutFooter>
        <PopoutAlign placement='left'>
          {shouldSendTrackingEvent ? (
            <LegacyLink newTab to='/account/pricing'>
              <Button
                color='upgrade'
                onClick={handleClick}
              >
                {translate('Upgrade')}
              </Button>
            </LegacyLink>
          ) : (
            <a
              href={WUFOO_PRICING_LINK}
              rel='noopener noreferrer'
              target='_blank'
            >
              <Button
                color='upgrade'
              >
                {translate('Upgrade')}
              </Button>
            </a>
          )}
        </PopoutAlign>
      </PopoutFooter>
    </Popout>
  )
}

UpgradePopout.defaultProps = {
  placement: 'right',
  renderTo: null,
  shouldSendTrackingEvent: false,
  trackingEventProps: {},
}

UpgradePopout.propTypes = {
  body: PropTypes.string.isRequired,
  placement: PropTypes.oneOf([ 'left', 'right', 'top', 'bottom' ]),
  renderTo: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.elementType })
  ]),
  shouldSendTrackingEvent: PropTypes.bool,
  trackingEventProps: PropTypes.shape({
    location: PropTypes.string,
    upgradeTextKey: PropTypes.string
  }),
  translate: PropTypes.func.isRequired,
  trigger: PropTypes.node.isRequired,
}

export default UpgradePopout
